'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';
import uiRouter from 'angular-ui-router';

export class NavbarComponent {
  constructor($scope, $state, $window, $cookies, authService){
    this.$state = $state;
    this.$window = $window;
    this.$cookies = $cookies;
    this.authService = authService;

    this.menu = [
      { title: 'Getting Started', state: 'publicDocumentation.getting_started', id: 'docs-public-route', show: () => true  },
      { title: 'Documentation', state: 'privateDocumentation.first_steps', id: 'docs-route', uris: ['/documentation'], show: authService.isLoggedIn },
      { title: 'APIs', state: 'apis', id: 'api-route', uris: ['apis'], show: authService.isLoggedIn },
      { title: 'Applications', state: 'apps', id: 'appilication-route', uris: ['/apps', '/editapp', '/application'], show: authService.isLoggedIn },
      { title: 'Monitoring', state: 'monitoring', id: 'monitoring-route', uris: ['/monitoring'], show: authService.isLoggedIn },
      { title: 'Support', state: 'support', id: 'support-route', uris: ['/support'], show: authService.isLoggedIn },
    ];
  }

  
  isCollapsed = true;

  navigateToMenu = function(item){    
    this.$state.go(item.state);
  };

  gotoRoot = function(){
    this.$window.location.href = '/';
  };

  isItemSelected = function(item){
    const href = this.$window.location.href;
    return item.uris ? item.uris.find(x => href.indexOf(x) >= 0) : false;
  }

  openProfile = () => {
    this.$state.go('profile');
  };
}

NavbarComponent.$inject = ['$scope', '$state', '$window', '$cookies', 'authService'];

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js